export function formatCurrency(value) {
  if (typeof value !== "number") value = parseFloat(value) || 0;
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(value);
}
